import PdfUpload from "./pdfUpload.component"

export default PdfUpload
